export default __webpack_public_path__ + "static/media/ellipse.67e18a78.svg";